module.exports = __webpack_public_path__ + "trunking-top-bw.svg?6a2654bbaef3770a030069c49ffd874d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/trunking-top-bw.svg
// module id = 75
// module chunks = 0